import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-gdpr-page',
  templateUrl: './gdpr-page.component.html',
  styleUrls: ['./gdpr-page.component.css']
})
export class GdprPageComponent implements OnInit {

  FIRMA = "##firma, sídlo, IČ##";

  placeholder;
  text = "Odesláním přihlášky uděluji svůj výslovní souhlas společnosti ##firma, sídlo, IČ## (dále jako \"poskytovatel\") a společnosti Ludicra s.r.o., se sídlem Zvěřinova 160/3, Brno 618 00, IČ: 03910482 (dále jako \"zpracovatel\"), aby ve smyslu zákona č. 101/2000 Sb., o ochraně osobních údajů zpracovávali tyto osobní údaje: jméno, příjmení, datum narození, e-mail, telefon. Tyto údaje budou poskytovatelem a zpracovatelem uchovávána po dobu neurčitou. Souhlas lze vzít kdykoliv zpět, a to zasláním e-mailu nebo dopisu na adresu poskytovatele a zpracovatele.";

  constructor(private activatedRoute: ActivatedRoute,) { }

  ngOnInit() {
    this.placeholder = localStorage.getItem("gdpr");
    console.dir(this.placeholder);
    this.text = this.text.replace(this.FIRMA, this.placeholder);
  }

}
